import DPIService from "../services/DPIService";
import { to } from "../../utils";
export default class DPIManager {
  dpiService: any;

  constructor() {
    this.dpiService = new DPIService()
  }
  // -------------------------------------------------- Admission Form
  getAdmissionForm = async emrId => {
    
    const [error, response, network] = await to(
      this.dpiService.getAdmissionForm(emrId)
    );
    return [response, error, network];
  };
  putAdmissionForm = async (emrId, data) => {
    
    const [error, response, network] = await to(
      this.dpiService.putAdmissionForm(emrId, data)
    );
    return [response, error, network];
  };

  createProgressionNote = async ({ apiToken, data } = {}) => {
    
    const [error, response, network] = await to(
      this.dpiService.createProgressionNote({ apiToken: apiToken, data: data })
    );
    return [response, error, network];
  };

  putProgressNote = async ({ apiToken, data = {}, emrId } = {}) => {
    let params: any = {}
    let saveData = { ...data }
    
    const [error, response, network] = await to(
      this.dpiService.putProgressNote({ apiToken, data: saveData, emrId, params })
    );
    return [response, error, network];
  };

  putProgressNoteById = async ({ apiToken, data = {}, progressNoteId } = {}) => {
    let params: any = {}
    let saveData = { ...data }
    
    const [error, response, network] = await to(
      this.dpiService.putProgressNoteById({ apiToken, data: saveData, progressNoteId, params })
    );
    return [response, error, network];
  };
}
